import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';
import { MasterOperatorType } from '../models/master-operator-type';
import { MasterOperatorWorkspace } from '../models/master-operator-workspace';

const COMPONENT_SELECTOR = 'tc-master-operator-workspace-form';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-workspace-form.component.html',
    styleUrls: ['./master-operator-workspace-form.component.scss'],
    standalone: false
})
export class MasterOperatorWorkspaceFormComponent implements OnInit {
  @Output() isValid = new EventEmitter<boolean>();
  @Output() valueChanges = new EventEmitter<MasterOperatorWorkspace>();

  form: UntypedFormGroup;
  readonly fieldAppearance = 'outline';
  readonly T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  readonly masterOperatorType = MasterOperatorType.Master;

  private _masterOperatorConnectItemSettings: MasterOperatorConnectItemsSettings;
  public get masterOperatorConnectItemSettings(): MasterOperatorConnectItemsSettings {
    return this._masterOperatorConnectItemSettings;
  }
  @Input() public set masterOperatorConnectItemSettings(value: MasterOperatorConnectItemsSettings) {
    this._masterOperatorConnectItemSettings = value;
  }
  @Input() showSubtitle = true;

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm(this.masterOperatorConnectItemSettings);
  }

  private buildForm(initialSettings: MasterOperatorConnectItemsSettings): void {
    const form = this._fb.group({
      name: [null, initialSettings ? [] : [Validators.required]],
      description: [null, []],
      masterConnectItemsSettings: [null, [Validators.required]],
    });

    form.valueChanges.subscribe((value) => {
      this.valueChanges.emit(value);
    });

    form.statusChanges.subscribe(() => {
      this.isValid.emit(this.form?.valid);
    });

    if (initialSettings) {
      form.controls['masterConnectItemsSettings'].setValue(initialSettings);
    }

    this.form = form;
  }
}
